<template>
  <div class="container-tooltip">
    <table>
      <tr class="container-tooltip__content">
        <td class="container-tooltip__content-label">{{ $t('searchLabel.templateName') }}:</td>
        <td class="container-tooltip__content-detail">{{ dataTooltip.eventTemplateName }}</td>
      </tr>
      <tr class="container-tooltip__content">
        <td class="container-tooltip__content-label">{{ $t('searchLabel.templateDesc') }}:</td>
        <td
          class="container-tooltip__content-detail template-desc"
          v-if="dataTooltip.eventTemplateDesc"
        >
          {{ dataTooltip.eventTemplateDesc || $t('message.nodata') }}
        </td>
        <td v-else class="container-tooltip__content-detail template-no-desc">
          {{ $t('message.nodata') }}
        </td>
      </tr>
    </table>
  </div>
</template>

<script>
export default {
  name: 'TooltipEventTemplate',
  props: {
    dataTooltip: {
      type: Object,
      default: () => {}
    }
  }
};
</script>

<style scoped lang="scss">
.container-tooltip {
  &__content {
    &-label {
      vertical-align: top;
      width: 80px;
    }
    &-detail {
      word-break: break-word;
    }

    .template-desc {
      display: -webkit-box;
      -webkit-line-clamp: 3;
      -webkit-box-orient: vertical;
      overflow: hidden;
      white-space: pre-wrap;
      text-overflow: ellipsis;
    }
    .template-no-desc {
      color: #ffffff;
      opacity: 0.5;
    }
  }
}
</style>
